import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { Modal } from "antd";
import { LoadingStatusCode } from "../../lib/types/LoadingStatusCode";
import { Accumulator, FetchAccumulatorsData } from "../../lib/interfaces/Accumulators";
import LoadingStatusCodes from "../../lib/const/loadingStatusCodes";
import getAccumulatorsRoute from "../../lib/routes/accumulators";

export type AccumulatorsState = {
  accumulators: Accumulator[];
  accumulatorsLoading: LoadingStatusCode;
};

const initialState: AccumulatorsState = {
  accumulators: [],
  accumulatorsLoading: LoadingStatusCodes.idle,
};

export const fetchAccumulators = createAsyncThunk(
  "accumulators/fetchAccumulators",
  (props: FetchAccumulatorsData) => {
    const url = getAccumulatorsRoute(props);
    return axios
      .get(url)
      .then(({ data }: { data: Accumulator[] }) => data)
      .catch((error) => {
        Modal.error({ title: "Ошибка загрузки аккумуляторов", content: error.message });
        throw new Error(error.message);
      });
  }
);

const accumulatorsSlice = createSlice({
  name: "accumulators",
  initialState,
  reducers: {
    cleanAccumulators: (state) => {
      state.accumulatorsLoading = LoadingStatusCodes.idle;
      state.accumulators = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccumulators.pending, (state) => {
        state.accumulatorsLoading = LoadingStatusCodes.pending;
      })
      .addCase(fetchAccumulators.rejected, (state) => {
        state.accumulatorsLoading = LoadingStatusCodes.rejected;
      })
      .addCase(fetchAccumulators.fulfilled, (state, { payload }) => {
        state.accumulatorsLoading = LoadingStatusCodes.fulfilled;
        state.accumulators = payload;
      });
  },
});

const { reducer, actions } = accumulatorsSlice;
const { cleanAccumulators } = actions;

export { reducer, cleanAccumulators };
